<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card>
        <el-container>
          <!-- 树状 -->
          <el-aside width="400px">
            <!-- 搜索框 -->
            <el-input placeholder="请输入组织名称页面过滤查询" v-model="filterText" clearable></el-input>

            <!-- 树 -->
            <el-tree class="filter-tree" :data="treeData" :props="defaultProps" :filter-node-method="filterNode"
              @node-click="handleNodeClick" ref="treeRef">
              <template #default="{ node, data }">
                <span class="custom-tree-item">
                  <span class="level-tag">{{ node.level }}</span>
                  <span class="tree-label">{{ data.name }}</span>
                </span>
              </template>
            </el-tree>
          </el-aside>
          <el-divider direction="vertical"></el-divider>

          <el-container>
            <!-- 查询框 -->
            <el-header>
              <div class="search-card">
                <el-form inline>
                  <el-form-item>
                    <el-button type="warning" size="mini" @click="teamsyncByOrgIdFun()">同步左侧组织</el-button>
                  </el-form-item>
                  <el-form-item label="账号名称:">
                    <el-input v-model="accountName" placeholder="可模糊查询" clearable size="mini"></el-input>
                  </el-form-item>
                  <el-form-item label="账号id:">
                    <el-input v-model="accountId" placeholder="请输入账号id" clearable size="mini"></el-input>
                  </el-form-item>
                  <!-- 其他筛选项 -->
                  <el-form-item>
                    <el-button type="success" size="mini" @click="teamAccountlistFun()">搜索</el-button>
                    <!-- <el-button size="mini">重置</el-button> -->
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" size="mini" @click="changetbviewFun()">同步子账户</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="warning" size="mini" @click="openorgMyListFun()">绑定组织和授权部门（账户隔离）</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-header>
            <el-main>
              <el-table :data="tableData" style="width: 100%" empty-text="暂无匹配的账户，请点击左侧组织节点">
                <el-table-column prop="accountName" label="账户信息" width="280"> </el-table-column>
                <!-- <el-table-column prop="accountId" label="账号id" width="180"> </el-table-column> -->
                <el-table-column prop="mail" label="(一级组织超管)邮箱" width="260"> </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
                <el-table-column prop="updateTime" label="修改时间" width="180"> </el-table-column>

                <!-- <el-table-column prop="regionRemark" label="操作" width="100">
                  <template #default="scope">
                    <el-button type="danger" @click="titledeleteFun2(scope)" icon="el-icon-delete" circle
                      size="mini"></el-button>
                  </template>
                </el-table-column> -->
              </el-table></el-main>
            <el-footer>
              <div class="pagination">
                <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
                  :total="total" :pagesize="pagesize" :currentPage="currentPage"></pagination>
              </div>
            </el-footer>
          </el-container>
        </el-container>
      </el-card>
    </div>

    <div>
      <!-- 同步管理弹窗控制 -->
      <el-dialog v-model="tbview" title="同步组织里的子账户" width="30%">
        <el-form label-width="120px">
          <el-form-item>
            <font style="color:red">是否确定同步？</font>
          </el-form-item>
        </el-form>
        <el-form-item>
          <el-button type="primary" size="mini" @click="teamAccountsyncByOrgIdFun()">确定同步</el-button>
          <el-button size="mini" @click="changetbviewFun()">取消</el-button>
        </el-form-item>
      </el-dialog>

      <!-- 绑定组织和授权部门 -->
      <el-dialog v-model="org.orgMyListView" title="绑定组织和授权部门" width="60%" destroy-on-close>
        <div style="margin-bottom: 12px; display: flex; gap: 8px;">
          <el-button type="primary" @click="openOrgsaveFun">添加组织</el-button>
          <el-button @click="refreshOrgMyListFun">刷新</el-button>
        </div>
        <!-- 搜索框 -->
        <el-input placeholder="组织名称(页面过滤)" v-model="org.filterText" clearable></el-input>
        <!-- 树 -->
        <el-tree class="filter-tree" :data="org.OrgTreeData" :props="defaultProps" :filter-node-method="filterNode"
          ref="orgTreeRef" :expand-on-click-node="false">
          <template #default="{ data }">
            <div class="tree-node">
              <span class="tree-node-label">
                <span class="level-tag">{{ data.depth ?? data.level }}</span>
                <span class="tree-label">{{ data.name }}</span>
              </span>
              <!-- 树节点三点操作 -->
              <el-dropdown trigger="click" @click.stop @command="(cmd) => handleOrgTreeCommand(cmd, data)">
                <span class="more-btn"><el-icon>
                    <MoreFilled />
                  </el-icon></span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="share">共享</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </template>
        </el-tree>
        <template #footer>
          <el-button @click="org.orgMyListView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 添加组织 -->
      <el-dialog v-model="org.orgsaveView" title="添加组织" width="30%" append-to-body destroy-on-close>
        <el-form label-width="90px">
          <el-form-item label="组织ID：">
            <el-input v-model="org.teamId" placeholder="请输入组织ID(teamId)" clearable />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="org.orgsaveView = false">取消</el-button>
          <el-button type="primary" @click="confirmOrgsaveFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 共享（仅部门共享）：左侧部门树 + 右侧当前组织共享记录 -->
      <el-dialog v-model="org.orgShareView" title="共享" width="80%" append-to-body destroy-on-close>
        <div class="share-tab-wrap">
          <el-row :gutter="12">
            <el-col :span="12">
              <el-card shadow="never" class="share-card">
                <template #header>
                  <div class="share-card-title">部门树（单击选择要共享的部门）</div>
                </template>
                <div style="margin-bottom: 8px; font-size: 13px;">
                  已选部门：<span style="color: #f56c6c;">{{ org.shareDeptName || '未选择' }}</span>
                </div>
                <el-tree ref="orgShareTreeRef" class="share-tree" :data="org.DeptData"
                  :props="{ children: 'children', label: 'label' }" node-key="id" default-expand-all
                  :expand-on-click-node="false" highlight-current @node-click="handleOrgShareDeptClick" />
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never" class="share-card">
                <template #header>
                  <div class="share-card-title flex-between">
                    <span>当前组织共享记录</span>
                    <span>共 {{ org.shareScopeDepts.length }} 条</span>
                  </div>
                </template>
                <el-table v-if="org.shareScopeDepts.length > 0" :data="org.shareScopeDepts" size="small"
                  style="width: 100%" empty-text="暂无共享记录">
                  <el-table-column prop="deptName" label="共享部门" min-width="120" show-overflow-tooltip />
                  <el-table-column prop="teamName" label="当前组织名称" width="280" />
                  <el-table-column prop="createTime" label="共享时间" width="180" />
                  <el-table-column label="操作" width="100">
                    <template #default="{ row }">
                      <el-button type="text" size="mini"
                        @click="openOrgShareCancelFun({ teamId: row.teamId ?? org.shareTeamId, deptId: row.deptId, deptName: row.deptName })">取消共享</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-empty v-else description="暂无共享记录" />
              </el-card>
            </el-col>
          </el-row>
        </div>
        <template #footer>
          <el-button @click="org.orgShareView = false">关闭</el-button>
          <el-button type="primary" :disabled="org.shareDeptIds.length === 0"
            @click="confirmOrgDeptShareFun">确定共享</el-button>
        </template>
      </el-dialog>

      <!-- 查看共享范围 -->
      <el-dialog v-model="org.orgShareScopeView" title="共享范围" width="30%" append-to-body destroy-on-close>
        <div v-if="org.shareScopeDepts && org.shareScopeDepts.length > 0">
          <el-tag v-for="item in org.shareScopeDepts" :key="item.id ?? item.deptId" closable
            style="margin: 0 8px 8px 0;" @close="openOrgShareCancelFun(item)">
            {{ item.deptId }}-{{ item.deptName }}
          </el-tag>
        </div>
        <el-empty v-else description="暂无共享部门" />
        <template #footer>
          <el-button @click="org.orgShareScopeView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 取消共享确认 -->
      <el-dialog v-model="org.orgShareCancelView" title="取消共享" width="30%" append-to-body destroy-on-close>
        <p>是否确定取消共享{{ org.cancelShareDeptName }}？</p>
        <template #footer>
          <el-button @click="org.orgShareCancelView = false">取消</el-button>
          <el-button type="danger" @click="confirmOrgShareCancelFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 删除组织确认 -->
      <el-dialog v-model="org.orgMyDeleteView" title="删除组织" width="30%" append-to-body destroy-on-close>
        <p>确定要删除《{{ org.deRemark }}》？</p>
        <template #footer>
          <el-button @click="org.orgMyDeleteView = false">取消</el-button>
          <el-button type="danger" @click="confirmOrgDeleteFun">确定</el-button>
        </template>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {
  teamAccountsyncByOrgId2, teamshareowneradd, teamshareteamTree, teamAccountlist, folderdeptTree,
  teamshareownerdelete, teamshareadd, teamshareshareInfoByOwner, teamsharecancel, teamsyncByOrgId, teamAccounttree
} from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { reactive, toRefs, watch, ref } from 'vue'
import { MoreFilled } from '@element-plus/icons-vue'
import pagination from '@/components/pagination.vue'

export default {
  name: 'gzt-sjb',
  components: { pagination, MoreFilled },
  setup() {
    //模板ref，不能放进reactive
    const treeRef = ref(null)
    const orgShareTreeRef = ref(null)
    const orgTreeRef = ref(null)

    const state = reactive({
      // ==========分页相关==========
      pagesize: 20,
      currentPage: 1,
      total: 100,
      tableData: [],
      accountId: '',
      accountName: '',

      //选中的节点id
      sid: '',
      depth: '',
      //获取角色权限编号 
      rId: localStorage.getItem('rId'),
      //获取角色名称 
      loginUserName: localStorage.getItem('userName'),
      //同步组织：未选中提示，选中则按选中teamId调用
      teamsyncByOrgIdFun: () => {
        if (state.sid === '' || state.sid == null) { ElMessage.error('请先选中组织'); return }
        teamsyncByOrgId({ orgId: state.sid }).then((res) => {
          if (res.code == 200) { ElMessage.success(res.msg || '同步组织成功'); }
          else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('同步组织失败') })
      },
      //同步开关
      tbview: false,
      //同步开关控制
      changetbviewFun: () => {
        state.tbview = !state.tbview
      },
      // ==========树相关参数==========
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      handleCurrentChange: (e) => {
        state.currentPage = e
        state.teamAccountlistFun()
      },
      handleSizeChange: (e) => {
        state.pagesize = e
        state.teamAccountlistFun()
      },
      //点击节点查询账户
      handleNodeClick: (data, node) => {
        state.sid = data.teamId ?? data.id
        state.depth = data.depth
        state.teamAccountlistFun()
      },
      //查询表格数据
      teamAccountlistFun: () => {
        if (state.sid != '') {
          const datas = {
            accountId: state.accountId,
            accountName: state.accountName,
            orgId: state.sid,
            currenPage: state.currentPage,
            size: state.pagesize,
          }
          teamAccountlist(datas).then((res) => {
            state.currentPage = res.data.currenPage
            state.total = res.data.totalSize
            state.tableData = res.data.data
          })
        } else {
          ElMessage.error('请先在左侧选中组织,再搜索')
        }

      },
      //同步
      teamAccountsyncByOrgIdFun: () => {
        if (state.sid != '') {
          const datas = {
            orgId: state.sid
          }
          teamAccountsyncByOrgId2(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success(res.msg)
              state.changetbviewFun()
            } else {
              ElMessage.error(res.msg)
            }
          })
        } else {
          ElMessage.error('请先在左侧选中组织再同步')
        }
      },
      // ==========绑定组织和授权部门（树展示，接口待替换）==========
      org: {
        orgMyListView: false,
        orgShareView: false,
        orgShareScopeView: false,
        shareScopeDepts: [],
        shareScopeConfigId: '',
        orgShareCancelView: false,
        cancelShareDeptId: '',
        cancelShareDeptName: '',
        orgMyDeleteView: false,
        orgsaveView: false,
        teamId: '',
        configId: '',
        shareDeptIds: [],
        shareDeptName: '',
        OrgTreeData: [],
        filterText: '',
        DeptData: [],
        key: '',
        deRemark: '',
      },
      openorgMyListFun: () => { state.refreshOrgMyListFun() },
      refreshOrgMyListFun: () => {
        teamshareteamTree({}).then((res) => {
          if (res.code == 200) { state.org.OrgTreeData = res.data || []; state.treeData = res.data || []; state.org.orgMyListView = true }
          else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('查询绑定组织失败') })
      },
      openOrgsaveFun: () => { state.org.teamId = ''; state.org.orgsaveView = true },
      // ==========弹窗内组织树节点三点操作：共享 / 删除==========
      handleOrgTreeCommand: (cmd, data) => {
        if (cmd === 'share') {
          state.openOrgShareFun({ config: { id: data.id }, id: data.id, teamId: data.teamId, shareDepts: data.shareDepts || [] })
        } else if (cmd === 'delete') {
          state.openOrgDeleteFun({ config: { id: data.id, teamName: data.name }, id: data.id, teamId: data.teamId, teamName: data.name, name: data.name })
        }
      },
      confirmOrgsaveFun: () => {
        if (!state.org.teamId && state.org.teamId !== 0) { ElMessage.error('请输入组织ID'); return }
        teamshareowneradd({ teamId: Number(state.org.teamId) }).then((res) => {
          if (res.code == 200) { ElMessage.success('添加组织成功'); state.org.orgsaveView = false; state.refreshOrgMyListFun(); teamshareteamTreeFun() }
          else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('添加组织失败') })
      },
      openOrgShareFun: (row) => {
        state.org.shareTeamId = row.teamId ?? (row.config ? row.config.teamId : undefined) ?? row.id
        state.org.configId = row.config ? row.config.id : row.id
        state.org.shareDeptIds = []; state.org.shareDeptName = ''
        state.org.shareScopeConfigId = row.config ? row.config.id : row.id
        state.org.shareScopeDepts = row.shareDepts || []
        state.org.orgShareView = true; state.getOrgDeptTreeFun(); state.getOrgShareInfoFun()
      },
      getOrgShareInfoFun: () => {
        if (state.org.shareTeamId === '' || state.org.shareTeamId == null) { return }
        teamshareshareInfoByOwner({ teamId: Number(state.org.shareTeamId) }).then((res) => {
          if (res.code == 200) {
            const list = res.data || []
            state.org.shareScopeDepts = (Array.isArray(list) ? list : []).map((item) => ({
              id: item.id,
              teamId: item.teamId,
              teamName: item.teamName,
              deptId: item.deptId,
              deptName: item.deptName,
              createTime: item.createTime,
            }))
          } else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('查询共享记录失败') })
      },
      handleOrgShareDeptClick: (data) => {
        state.org.shareDeptIds = [data.id]; state.org.shareDeptName = data.label
        if (orgShareTreeRef.value) { orgShareTreeRef.value.setCurrentKey(data.id) }
      },
      openOrgShareScopeFun: (row) => {
        state.org.shareScopeConfigId = row.config ? row.config.id : row.id
        state.org.shareScopeDepts = row.shareDepts || []
        state.org.orgShareScopeView = true
      },
      openOrgShareCancelFun: (item) => {
        state.org.cancelShareDeptId = item.deptId; state.org.cancelShareDeptName = item.deptName
        state.org.cancelShareTeamId = item.teamId ?? state.org.shareTeamId
        state.org.orgShareCancelView = true
      },
      confirmOrgShareCancelFun: () => {
        if (state.org.cancelShareTeamId === '' || state.org.cancelShareTeamId == null) { ElMessage.error('缺少组织ID，无法取消共享'); return }
        if (state.org.cancelShareDeptId === '' || state.org.cancelShareDeptId == null) { ElMessage.error('缺少部门ID，无法取消共享'); return }
        teamsharecancel({ teamId: Number(state.org.cancelShareTeamId), deptId: Number(state.org.cancelShareDeptId) }).then((res) => {
          if (res.code == 200) {
            ElMessage.success('已取消共享' + (state.org.cancelShareDeptName || ''))
            state.org.orgShareCancelView = false
            state.org.shareScopeDepts = (state.org.shareScopeDepts || []).filter((i) => i.deptId !== state.org.cancelShareDeptId)
            state.org.cancelShareDeptId = ''; state.org.cancelShareDeptName = ''; state.org.cancelShareTeamId = ''
            state.getOrgShareInfoFun()
          } else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('取消共享失败') })
      },
      getOrgDeptTreeFun: () => {
        folderdeptTree({}).then((res) => {
          if (res.code == 200) { state.org.DeptData = res.data || [] }
          else { ElMessage.error(res.msg) }
        })
      },
      confirmOrgDeptShareFun: () => {
        if (!state.org.shareDeptIds || state.org.shareDeptIds.length === 0) { ElMessage.error('请先点击选择要共享的部门'); return }
        teamshareadd({ teamId: Number(state.org.shareTeamId), deptId: Number(state.org.shareDeptIds[0]) }).then((res) => {
          if (res.code == 200) { ElMessage.success('授权成功'); state.org.orgShareView = false; state.refreshOrgMyListFun() }
          else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('授权失败') })
      },
      openOrgDeleteFun: (row) => {
        state.org.key = row.teamId ?? (row.config ? row.config.teamId : undefined) ?? row.id
        state.org.deRemark = row.config ? (row.config.teamName || row.config.name) : (row.teamName || row.name || '')
        state.org.orgMyDeleteView = true
      },
      confirmOrgDeleteFun: () => {
        teamshareownerdelete({ teamId: Number(state.org.key) }).then((res) => {
          if (res.code == 200) { ElMessage.success('删除成功'); state.org.orgMyDeleteView = false; state.refreshOrgMyListFun(); teamshareteamTreeFun() }
          else { ElMessage.error(res.msg) }
        }).catch(() => { ElMessage.error('删除失败') })
      },

    })

    //================ setup顶层函数（和你示例handleSelectionChange同一层级）================
    /**树过滤回调，放在setup顶层，不放入state */
    const filterNode = (value, data) => {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }


    //查询树
    const teamAccounttreeFun = () => {
      teamAccounttree({}).then((res) => {
        state.treeData = res.data
      })
    }





    //查询树
    const teamshareteamTreeFun = () => {
      teamshareteamTree().then((res) => {
        state.treeData = res.data
      })
    }


    // 判断身份
    const selectRID = () => {
      if (state.loginUserName == '黄彬' || state.loginUserName == '任文龙') {
        // 管理员看全部
        teamAccounttreeFun()
      } else {
        teamshareteamTreeFun()
      }
    }

    selectRID()



    /**监听树搜索 */
    watch(
      () => state.filterText,
      (val) => {
        treeRef.value?.filter(val)
      }
    )
    /**监听弹窗内组织树搜索 */
    watch(
      () => state.org.filterText,
      (val) => {
        orgTreeRef.value?.filter(val)
      }
    )



    //======= return范式： ...toRefs(state) ，再追加顶层ref、顶层函数 =======
    return {
      treeRef,
      orgTreeRef,
      orgShareTreeRef,
      ...toRefs(state),
      filterNode,
      teamAccounttreeFun,
      teamshareteamTreeFun,
      selectRID,
    }
  },
}
</script>

<style lang="scss" scoped>
.filter-tree {
  margin-top: 10px;
}

.custom-tree-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.level-tag {
  background-color: #e5e7eb;
  color: #666;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.tree-label {
  font-size: 14px;
}

.tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  padding-right: 4px;
}

.tree-node-label {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.more-btn {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  color: #606266;
  font-size: 18px;
  font-weight: 700;
  border-radius: 4px;
  cursor: pointer;
  background: #f0f2f5;
  visibility: visible;
  opacity: 1;

  &:hover {
    color: #fff;
    background: #409eff;
  }
}

.share-tab-wrap {
  min-height: 360px;
}

.share-card {
  height: 100%;
}

.share-card-title {
  font-size: 14px;
  font-weight: 600;
}

.share-tree {
  max-height: 420px;
  overflow-y: auto;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.downBtn {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}
</style>